import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography
} from '@material-ui/core';
import React, { useState } from 'react';

interface AddSenderToIgnoredListDialogProps {
    senderEmail: string;
    onClose: () => void;
    onConfirm: (regexPattern: string) => void;
}

export const AddSenderToIgnoredListDialog: React.FC<AddSenderToIgnoredListDialogProps> = ({
    senderEmail,
    onClose,
    onConfirm
}) => {
    const [selectedOption, setSelectedOption] = useState<'specific' | 'domain'>('specific');

    const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(event.target.value as 'specific' | 'domain');
    };

    const getRegexPattern = (): string => {
        if (selectedOption === 'specific') {
            // Escape special regex characters in email
            return senderEmail.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        } else {
            // Extract domain and create pattern for any user at that domain
            const domain = senderEmail.split('@')[1];
            // Escape special regex characters in domain
            const escapedDomain = domain.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            return `.*@${escapedDomain}`;
        }
    };

    const handleConfirm = () => {
        const pattern = getRegexPattern();
        if (pattern) {
            onConfirm(pattern);
        }
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle>
                <Typography variant="h4" component="div">
                    Add Sender to Ignored List
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography style={{ marginBottom: 10 }}>
                    Choose how you want to ignore emails from <strong>{senderEmail}</strong>:
                </Typography>

                <FormControl component="fieldset" className="option-group">
                    <RadioGroup value={selectedOption} onChange={handleOptionChange}>
                        <FormControlLabel
                            value="specific"
                            control={<Radio />}
                            label={`Ignore only this specific email address: ${senderEmail}`}
                        />
                        <FormControlLabel
                            value="domain"
                            control={<Radio />}
                            label={`Ignore all emails from domain: @${senderEmail.split('@')[1]}`}
                        />
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="default">
                    Cancel
                </Button>
                <Button onClick={handleConfirm}>Add to Ignored List</Button>
            </DialogActions>
        </Dialog>
    );
};
